import * as React from "react";
const SvgDoneIcon = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 19, height: 19, fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M2.375 14.25 7.125 17 17 2.375", style: {
  stroke: "#a48ad2",
  strokeWidth: 2,
  fill: "none"
} }));
export default SvgDoneIcon;
